import Alpine from 'alpinejs'
import { leaseTypes } from '../leaseTypes'
import { Endpoints } from '../site'

// The initial type data
const initialTypeData = [
  {
    label: '',
    id: '',
    cities: [
      {
        id: 0,
        name: '',
        area: '',
        zip_code_from: 0,
        zip_code_to: 0,
        slug: '',
      },
    ],
  },
]

document.addEventListener('alpine:init', () => {
  Alpine.data('sitemap', () => ({
    typeData: initialTypeData,

    fetchCitites(index: number) {
      return fetch(
        `${import.meta.env.MIX_API_BASE as string}${Endpoints.cities}?sortby=name&direction=asc&lease_type=${this.typeData[index].id}`
      )
        .then((response) => response.json())
        .then((data) => {
          return (this.typeData[index].cities = data.data)
        })
    },

    mapTypes() {
      const mappedTypes = leaseTypes.map((type) => ({
        label: type.label,
        id: type.id,
        cities: [],
      }))
      return (this.typeData = mappedTypes)
    },

    async init() {
      await this.mapTypes()
      for (var i = 0; i < this.typeData.length; ++i) {
        this.fetchCitites(i)
      }
    },
  }))
})
